import React from 'react';
import { CssTextField } from '../styles/styles';
import { Padding } from '@mui/icons-material';
import { Typography } from '@mui/material';

const FreeTextField = ({ label, tituloEncuesta, setTituloEncuesta, setErrorTituloEncuesta, errorTituloEncuesta }) => {
    return (
        <div>
            <Typography variant={'body1'} style={{ marginBottom: Padding.P2 }}>
                {label}
            </Typography>

            <CssTextField
                value={tituloEncuesta || ''}
                onChange={(e) => {
                    setTituloEncuesta(e.target.value);
                    setErrorTituloEncuesta(false);
                }} 
                placeholder={label}
                variant="outlined"
                margin="normal"
                fullWidth
                error={errorTituloEncuesta}
                helperText={errorTituloEncuesta ? 'Campo requerido' : ''}
            />
        </div>
    );
};
export default FreeTextField;